import React, { useContext } from 'react';
import { Texture, TextStyle } from 'pixi.js'
import { Sprite, Container, Text } from '@inlet/react-pixi'
import { useHistory } from "react-router-dom";
import { ease } from 'pixi-ease'

import HomeContext from '../../../context/home-context';
import { claimDailyChest } from '../../../actions/home-actions'
import { getStudentNumberFromSession } from '../../../utils/helpers/others/SessionHelper'

const domElement = document.querySelector('#root');
let initWidth = domElement.offsetWidth;
let initHeight = domElement.offsetHeight;

const FlyingFoodAnimationModal = ({ _isOpen, _notiCloseClick }) => {
    const history = useHistory();
    const { homeContext, dispatch } = useContext(HomeContext);
    const mainFood = React.useRef();
    const food1 = React.useRef();
    const food2 = React.useRef();
    const food3 = React.useRef();
    const btnId = React.useRef();

    if (initWidth < 2000) {
        initWidth = 1920;
        initHeight = 900;
    }
    let boxInitX = (initWidth - 560) / 2;
    let boxInitY = (initHeight - 250) / 2;

    const titleStyle2 = new TextStyle({
        fontFamily: '"Source Sans Pro", Helvetica, sans-serif',
        fontSize: 20,
        fill: "black",
        wordWrap: true,
        wordWrapWidth: 300,
        align: "center",

    });
    let drumstickTexture = Texture.from('./assets/images/components/island/particle/drumstick.png');
    let berryTexture = Texture.from('./assets/images/components/island/particle/berry.png');
    let alertTexture = Texture.from(`./assets/images/components/island/particle/alert_box.png`);
    let transparentTexture = Texture.from(`./assets/images/components/island/particle/transparentBG.png`);
    let awesomeBtn = Texture.from(`./assets/images/components/island/particle/awesome.png`);

    const animateToTop = () => {
        if (food1.current !== null && food1.current !== undefined) {
            btnId.current.buttonMode = btnId.current.interactive = btnId.current.visible = false;
            food1.current.visible = food2.current.visible = food3.current.visible = true;
            ease.add(food1.current, { position: { x: 5, y: 85 } }, { reverse: false, duration: 1000 })
            ease.add(food2.current, { position: { x: 5, y: 85 } }, { reverse: false, duration: 1500 })
            const example3 = ease.add(food3.current, { position: { x: 5, y: 85 } }, { reverse: false, duration: 2000 })
            example3.once('complete', async () => {

                if (food1.current !== null && food1.current !== undefined) {

                    food1.current.visible = food2.current.visible = food3.current.visible = false;

                    let response = await claimDailyChest(getStudentNumberFromSession());
                    if (response > 200 || response.status === "Failed") {
                        return history.push("/SessionTimeOut")
                    }

                    if (response.status === "Success") {
                        homeContext.dailyChestClaim.ableToClaim = false;
                        homeContext.dailyChestClaim.foodCount = response.data;
                        dispatch({ type: 'SET_DAILYCHESTCLAIM', dailyChestClaim: homeContext.dailyChestClaim });
                    }
                    else {
                        alert("Something went wrong");
                    }

                    _notiCloseClick();
                }
            })
        }
    }

    return (
        <>
            {
                _isOpen ?
                    <>
                        <Container>
                            <Sprite width={initWidth} height={initHeight} texture={transparentTexture} interactive={true} />
                        </Container>
                        <Container x={boxInitX} y={boxInitY}>
                            <Sprite
                                texture={alertTexture}
                            />
                            <Sprite ref={mainFood}
                                scale={{ x: 0.2, y: 0.2 }}
                                x={250}
                                y={30}
                                texture={homeContext.monsterMenu.cluster === "ENG" || homeContext.monsterMenu.cluster === "CEFT" ? berryTexture : drumstickTexture}
                            />
                            <Text
                                text={`You\'ve successfully collected your dinosaur food!`}
                                x={150}
                                y={105}
                                style={titleStyle2}
                            />
                            <Sprite ref={btnId}
                                texture={awesomeBtn}
                                x={200}
                                y={155}
                                interactive={true} buttonMode={true}
                                pointerdown={() => {
                                    animateToTop()
                                }}
                            />
                        </Container>
                    </>
                    :
                    <></>
            }
            {
                <>
                    <Sprite
                        visible={false}
                        ref={food1}
                        texture={homeContext.monsterMenu.cluster === "ENG" || homeContext.monsterMenu.cluster === "CEFT" ? berryTexture : drumstickTexture}
                        x={boxInitX + 260}
                        y={boxInitY + 50}
                        scale={{ x: 0.2, y: 0.2 }}
                    />
                    <Sprite
                        visible={false}
                        ref={food2}
                        texture={homeContext.monsterMenu.cluster === "ENG" || homeContext.monsterMenu.cluster === "CEFT" ? berryTexture : drumstickTexture}
                        x={boxInitX + 260}
                        y={boxInitY + 50}
                        scale={{ x: 0.2, y: 0.2 }}
                    />
                    <Sprite
                        visible={false}
                        ref={food3}
                        texture={homeContext.monsterMenu.cluster === "ENG" || homeContext.monsterMenu.cluster === "CEFT" ? berryTexture : drumstickTexture}
                        x={boxInitX + 260}
                        y={boxInitY + 50}
                        scale={{ x: 0.2, y: 0.2 }}
                    />
                </>
            }
        </>
    );
}

export { FlyingFoodAnimationModal as default }